// extracted by mini-css-extract-plugin
export default {"question":"Faq_question__cY--0","answer":"Faq_answer__sc5jg","container":"Faq_container__tSK17","line":"Faq_line__tsyHf","contact":"Faq_contact__tEY54"};